import React, { FC } from 'react';
import { AdvancedFilters } from '../../advanced_filters/AdvancedFilters';
import { WORK_ORDER_SORTERS } from '../config/sorters/sorters';

interface FiltersProps {
	filters: any;
	applyFilters: any;
	clearFilters: any;
	targetCollectionName: String;
	filterConfig: any;
	userType: any;
	sorters: any;
	applySorting: any;
	preAppliedFilters: any;
	currentUser: any;
	sorterItems: any;
}

const Filters: FC<FiltersProps> = ({
	preAppliedFilters,
	filters,
	applyFilters,
	applySorting,
	clearFilters,
	targetCollectionName,
	filterConfig,
	sorters,
	sorterItems = WORK_ORDER_SORTERS,
}): React.ReactElement => {
	return (
		<AdvancedFilters
			updateFilters={applyFilters}
			filterConfig={filterConfig}
			filtersTargetCollectionName={targetCollectionName}
			clearAndUpdateFilters={clearFilters}
			initialFilters={filters}
			filtersStateSlice={filters}
			applySorting={applySorting}
			sorters={sorters}
			sorterItems={sorterItems}
			preAppliedFilters={preAppliedFilters}
		/>
	);
};

export default Filters;
